(function () {

function render_announcement_bar () {
  const announcement_bar = document.querySelector('.announcement-bar');
  if (announcement_bar) {
    const announcements = [
      {
        start: '2026-11-01T00:00',
        end: '2026-12-01T00:00',
        html: `
          <p>
            <a href="${window_api_data.root_url}/pages/needessentials-simon-jones-designs-surfboard-giveaway">Purchase any need<strong>essentials</strong> product this November and go into the draw to win Simon Jones x Torren Martyn Twin Fin Surfboard</a>
          </p>
        `,
      },
    ];

    const current_datetime = new Date(window_api_data.shop_datetime);
    const current_announcement = announcements.find(announcement => {
      const start_datetime = new Date(announcement.start);
      const end_datetime = new Date(announcement.end);
      return current_datetime >= start_datetime && current_datetime < end_datetime;
    });

    if (current_announcement) {
      announcement_bar.innerHTML = current_announcement.html;
      announcement_bar.style.display = 'block';
    } else {
      announcement_bar.style.display = 'none';
    }

  }
}

window.render_announcement_bar = render_announcement_bar;

})()
